import { useSelector } from "react-redux";
import { AppState } from "store";

import useDeviationPermissions from "components/salaryDeviation/usePermissions";

function useGrossSalaryChangePermissions() {
  const { isSalaryAdmin, isBusinessUnitManagerWithSalaryRights } = useDeviationPermissions();
  const loggedInPersonId = useSelector((state: AppState) => state.auth.loggedInUser.personId);
  const { wintSalaryCompanySettings } = useSelector((state: AppState) => state.auth.selectedCompany);
  const grossSalaryChangeEnabled = wintSalaryCompanySettings?.grossSalaryChangeEnabled ?? false;

  const canChangeGrossSalary = (targetPersonId: number): boolean => {
    if (!grossSalaryChangeEnabled) return false;
    if (isSalaryAdmin) return true;
    if (isBusinessUnitManagerWithSalaryRights) {
      return targetPersonId !== loggedInPersonId;
    }
    return false;
  };

  return { canChangeGrossSalary };
}

export default useGrossSalaryChangePermissions;
